import React from "react";
import Loader from "../loader";
import Expandable from "../../containers/expandable";
import { niceEventName } from "../../../helpers/sport/eventNames";
import Helpers from "../../../helpers/helperFunctions";
import Event from "../event";
import { t } from "../../../helpers/translator";
import InfoBlock from "../infoBlock";

export default function marketTemplate () {
    let { market, game, marketName, isFavoritesMarket, index, boostedOdds, gameType } = this.props;

    let Events = market.map(
        market => {
            let events = Helpers.objectToArray(market.event).sort(Helpers.byOrderSortingFunc),
                colCount = market.col_count ? (market.col_count > 4 ? 1 : market.col_count) : 1,
                rows = [];
            colCount === 3 && market.type === "OutcomeandBothTeamToScore" && (colCount = 2);
            while (events.length) {
                rows.push(events.splice(0, colCount));
            }
            return rows.map((row, i) =>
                <ul className="coefficient-game-view" key={i}>
                    {row.map(event =>
                        <li key={event.id}>
                            <Event event={event} name={niceEventName(event.name, this.props.game)} price={event.price} game={game} market={market} boostedOdds={boostedOdds} gameType={gameType}/>
                        </li>
                    )}
                </ul>
            );
        }
    );
    if (market && game) {
        const notificationInfo = this.showNotification(market);
        return <div className="singe-market-view-m">
            <Expandable className={"single-market-title-m "} uiKey={market[0].id} initiallyExpanded={index < 3}>
                <span className={`fav-star-m ${isFavoritesMarket ? "active" : ""}`} onClick={this.setFavoritesMarket(marketName)} />
                <h4>
                    
                    <span className="name-market-contain-cell-m"><i>{niceEventName(marketName, game)} {!!notificationInfo && <InfoBlock info={notificationInfo}/>}</i></span>
                    <span className="market-icons-cell-m">
                        {market[0].cashout ? <i className="cash-out-icon-view-m" /> : null}
                        {market[0].express_id ? <i className="chain-icon-view-m">{market[0].express_id}</i> : null}
                    </span>
                </h4>
                <div className="markets-closed-open-arrow-m" />
            </Expandable>
            {
                Events
            }
        </div>;
    } else {
        return <Loader />;
    }
}